var Isotope = require('isotope-layout');

export default {
    init() {
        var qsRegex;
        var $isoArticles = new Isotope( '.grid--articles', {
            itemSelector: '.grid__elem',
            layoutMode: 'fitRows',
            hiddenStyle: {
                opacity: 0,
            },
            visibleStyle: {
                opacity: 1,
            },
            transitionDuration: '0.8s',
            filter: function () {
                return qsRegex ? $(this).data('keywords').match(qsRegex) : true;
            },
        });

        /* eslint-disable no-undef, no-unused-vars */
        $('.load-more-ajax').on('click', function() {
            var button = $(this),
                data = {
                    'action': 'load_more',
                    'query': load_more.posts,
                    'page' : load_more.current_page,
                    'nonce': load_more.nonce,
                },
                type = button.data('type');
            $.ajax({
                url : load_more.ajaxurl,
                data : data,
                type : 'POST',
                success : function( data ){
                    if( data ) {
                        //reset button text

                        var elements = $.parseHTML(data)

                        if (type == 'standard') {
                            $('.row--articles').append(elements);
                        } else if (type == 'filter') {
                            $(elements).addClass('grid__elem-hidden')

                            $('.grid--articles').append(elements);

                            $isoArticles.appended( elements );
                            $isoArticles.layout();

                            setTimeout(() => {
                                $('.grid__elem-hidden').removeClass('grid__elem-hidden')
                            }, 500);
                        }

                        load_more.current_page++;
                        if ( load_more.current_page == load_more.max_page )
                            button.remove();

                    } else {
                        button.remove();
                    }
                },
            });
        });
        /* eslint-enable no-undef, no-unused-vars */

        $('.js-clear').on('click', function (e) {
            e.preventDefault()

            var form = $(this).closest('form'),
                input = $(this).closest('form').find('.quicksearch');

            input.val('');
            form.trigger('submit');
        });


        $('.form--filter').on('submit', function (e) {
            e.preventDefault()

            var input = $(this).find('.quicksearch');
            qsRegex = new RegExp(input.val(), 'gi');
            $isoArticles.arrange();
        });
    },
    finalize() {
        // JavaScript to be fired on all pages, after page specific JS is fired
    },
};
